import { SafeHtml } from "@angular/platform-browser";

export interface SEND_MESSAGE_BODY {
  sent_by: string;
  sent_to?: string;
  message?: string;
  send_toUsers?: string[];
  group_id?: string;
  file?: string;
  // Set when editing: the send endpoints update instead of inserting.
  message_id?: string;
}

export interface EDIT_MESSAGE {
  isGroup: boolean;
  message_id: string;
  message: string;
}

export interface GET_MESSAGE_LIST {
  sent_by: string;
  sent_to: string;
  isGroup?: boolean;
}

export interface MESSAGE_DETAIL {
  id: string;
  is_reported: string;
  message: string | SafeHtml;
  receiver_image: string;
  sender_image: string;
  sender_name: string;
  sent_by: string;
  sent_on: Date | string;
  sent_to: string;
  filename: string
}

export interface MESSAGE_GROUP_DETAIL {
  chat_id: string;
  message: string | SafeHtml;
  sender_image: string;
  sender_name: string;
  sent_by: string;
  sent_on: string;
  filename: string
}

export interface CREATE_GROUP {
  group_name: string;
  group_status: string;
  chatusers: string[];
  group_id?: string;
}

export interface GROUP_DETAIL {
  chatgroup_id: string;
  chatgroup_name: string;
  user_ids: GROUP_USERS[];
  createdBy: string;
}

export interface GROUP_USERS {
  user_firstname: string;
  user_lastname: string;
  users_id: string;
  profile_photo: string;
}

export interface GROUP_LIST {
  chatgroup_id: string;
  chatgroup_name: string;
  createdBy: string;
  createdOn: string;
  customer_id: string;
  status: string;
  createdby_firstname: string;
  createdby_lastname: string;
  group_users?: GROUP_MEMBER[];
}

export interface GROUP_MEMBER {
  chatgroup_id?: string;
  users_id: string;
  user_firstname: string;
  user_lastname: string;
}

export interface CHAT_HEADER {
  title: string;
  description: string;
  group_check: boolean;
  profile_picture: string;
  id: string;
  createdBy?: string;
}

export interface HttpChatCounterResponse {
  data: number;
  group_listData: string[];
  message: string;
  singleChat_sentby: string[];
  status: boolean;
}

export interface CHAT_COUNTER {
  data: number;
  group_listData: any[];
  singleChat_sentby: any[];
}